module.exports = __webpack_public_path__ + "img/avatar_placeholder.76eda3e6.png";